// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"_3NPyF_85Mtq0_EbWhfeo8K","title":"_1n11hT0Nr5ZB7gcH9TkGy5","message":"_2nCUAkiT5NL0vV_hMysBW_","cta":"_1TC3ZQZ8Bo6Am9m2_1086I","supportLink":"_2QHGWhdoSLhZPaS_DYNZJD"};